import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/checked",
  "use": "app/checked-usage",
  "viewBox": "0 0 26 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 27\" id=\"app/checked\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23.392 7.458L9.908 20.12 2 12.214 3.414 10.8l6.537 6.537L22.023 6l1.369 1.458z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol